/**
 * Element properties whose stored numeric values are scaled to `%` in proposal/action UI.
 * {@link scaleMax} is passed to {@link scaleStoredNumberToDisplayPercent}.
 *
 * Display strings feed {@link ELEMENT_PROPERTY_DISPLAY_NAME_RECORD} in action.helpers — keep keys in sync.
 */
export const ELEMENT_PERCENT_PROPERTY_ENTRIES = {
  reused_content: { displayLabel: 'Reuse', scaleMax: 100 },
  content_coverage: { displayLabel: 'Content coverage', scaleMax: 1 },
} as const;

/** Maps technical property name → scale max for fraction→percent conversion. */
export const ELEMENT_PERCENT_PROPERTY_SCALE_MAX: Readonly<
  Record<string, number>
> = Object.fromEntries(
  Object.entries(ELEMENT_PERCENT_PROPERTY_ENTRIES).map(
    ([key, { scaleMax }]) => [key, scaleMax],
  ),
);
